import { render, staticRenderFns } from "./BotonLinkMenu.vue?vue&type=template&id=fc0b077e&scoped=true&"
import script from "./BotonLinkMenu.vue?vue&type=script&lang=ts&"
export * from "./BotonLinkMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BotonLinkMenu.vue?vue&type=style&index=0&id=fc0b077e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0b077e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fc0b077e', component.options)
    } else {
      api.reload('fc0b077e', component.options)
    }
    module.hot.accept("./BotonLinkMenu.vue?vue&type=template&id=fc0b077e&scoped=true&", function () {
      api.rerender('fc0b077e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiApp/reusables/BotonLinkMenu.vue"
export default component.exports